export default function Checkbox({
  checked = false,
  disabled = false,
  onChange,
  className = '',
  'aria-labelledby': ariaLabelledBy,
  ...rest
}) {
  return (
    <label
      className={[
        'relative block h-6 w-6 shrink-0 self-start',
        disabled ? 'cursor-not-allowed' : 'cursor-pointer',
        className,
      ].join(' ')}
    >
      <input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={(event) => onChange?.(event.target.checked, event)}
        aria-labelledby={ariaLabelledBy}
        className={[
          'peer absolute left-1/2 top-1/2 h-tap-target w-tap-target',
          '-translate-x-1/2 -translate-y-1/2 appearance-none opacity-0',
          'focus:outline-none',
          disabled ? 'cursor-not-allowed' : 'cursor-pointer',
        ].join(' ')}
        {...rest}
      />

      <span
        aria-hidden="true"
        data-state={checked ? 'checked' : 'unchecked'}
        className={[
          'pointer-events-none flex h-6 w-6 items-center justify-center',
          'rounded-home-8 border-checkbox',
          'transition-[background-color,border-color,opacity] duration-checkbox ease-out',
          'peer-focus-visible:ring-checkbox peer-focus-visible:ring-base-white',
          checked
            ? 'border-transparent bg-icon-accent'
            : 'border-glass-stroke-end bg-transparent',
          disabled ? 'opacity-40' : 'opacity-100',
        ].join(' ')}
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          className={[
            'h-6 w-6 text-text-inverse',
            'transition-[transform,opacity] duration-checkbox ease-out',
            checked ? 'scale-100 opacity-100' : 'scale-75 opacity-0',
          ].join(' ')}
        >
          <path
            d="M5.5 12.5L10 17L18.5 7.5"
            stroke="currentColor"
            className="stroke-checkbox"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
    </label>
  );
}
